import { styled } from "@monolith-forensics/monolith-ui";

import { Office } from "../offices.types";
import { OfficesItem } from "./OfficesItem";

export interface OfficesListProps {
  className?: string;
  offices: Office[];
}

export const OfficesList = styled(
  ({ className, offices }: OfficesListProps) => {
    return (
      <div className={className}>
        <div className="offices-list-container">
          {offices.map((office) => (
            <OfficesItem key={office.office_id} office={office} className="" />
          ))}
        </div>
      </div>
    );
  }
)`
  & {
    height: 100%;
    overflow-y: auto;
  }
  .offices-list-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    grid-gap: 20px;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    padding-right: 8px;
  }
`;
